/** My tasks across every Hub and My Day (Epic 8) — any change may touch them. */
export const ME_KEY = ["tasks", "me"] as const;
